<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>ការគ្រប់គ្រងដៃគូសហការ</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-50">
								<div class="md-layout-item md-small-size-100 md-size-100">
									<h3>ព័ត៌មានដៃគូសហការ</h3>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100 text-right">
									<span class="late">* តម្រូវបំពេញ</span>
								</div>
								<div class="md-layout">
									<div class="md-layout-item md-small-size-100 md-size-66">
										<md-field>
											<label>ឈ្មោះដៃគូសហការ *</label>
											<md-input type="text" v-model="partner.name"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-33">
										<md-field>
											<label>ភាគលាភត្រូវចែក *</label>
											<md-input type="number" v-model="partner.dividend"></md-input>
										</md-field>
									</div>
									
									<div class="md-layout-item md-small-size-100 md-size-100">
										<md-field>
											<label>កំណត់ចំណាំ</label>
											<md-input type="text" v-model="partner.note">
											</md-input>
										</md-field>
									</div>
								</div>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-50">
								<div class="md-layout-item md-small-size-100 md-size-100">
									<h3>ព័ត៌មានសង្ខេប</h3>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-table>
										<md-table-row>
											<md-table-cell style="width: 50%;">ឈ្មោះដៃគូសហការ</md-table-cell>
											<md-table-cell style="width: 5px">:</md-table-cell>
											<md-table-cell>
												<span v-if="String(partner.name).length > 0">{{partner.name}}</span>
												<span v-else>មិនមាន</span>
											</md-table-cell>
										</md-table-row>
										<md-table-row>
											<md-table-cell style="width: 50%;">ភាគលាភត្រូវចែក</md-table-cell>
											<md-table-cell style="width: 5px">:</md-table-cell>
											<md-table-cell>
												<span v-if="String(partner.dividend).length > 0">{{partner.dividend}}%</span>
												<span v-else>មិនមាន</span>
											</md-table-cell>
										</md-table-row>
										
										<md-table-row>
											<md-table-cell>កំណត់ចំណាំ</md-table-cell>
											<md-table-cell>:</md-table-cell>
											<md-table-cell>
												<span v-if="String(partner.note).length > 0">{{partner.note}}</span>
												<span v-else>មិនមាន</span>
											</md-table-cell>
										</md-table-row>
									</md-table>
								</div>
							</div>
							<div class="md-layout-item md-size-100 text-right">
								<md-button class="md-raised md-primary" @click="updatePartner()">កែប្រែព័ត៌មាន</md-button>
							</div>
						</div>
					</div>
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
	import { Datetime } from 'vue-datetime';
	import { Settings } from 'luxon'
	Settings.defaultLocale = 'km'
	export default {
		components: {
			datetime: Datetime
		},
		created() {
			this.getPartner();

		},
		data() {
			return {
				loaded: false,
				partner: {
					valid: false,
					name: "",
					dividend: "",
					note: ""
				},
			}
		},
		methods: {
			getPartner() {
				this.$http.get(this.config.api + "/user/partner/get/" + this.$route.params.hash).then(data => {
					this.partner = data.body.data
					this.loaded = true;
				})
			},
			updatePartner() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/user/partner/update", {
					hash: this.$route.params.hash,
					partner: this.partner
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "ដែគូសហការត្រូវបានធ្វើបច្ចប្បន្នភាពជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.$router.push("/partners");
					}
				})
			},
			checkValidation() {
				if (String(this.partner.name).length > 0 && String(this.partner.dividend).length > 0 && parseInt(this.partner.dividend) <= 100 && parseInt(this.partner.dividend) > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបំពេញព័ត៌មានបន្ថែម",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			}
		}
	}
</script>
<style>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50% !important;
	}

	.file-image-wrapper {
		/* margin: 10px; */
		width: calc(100%);
		padding-top: 8px;
		padding-bottom: 5px;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

	.file-image {
		margin-top: 21px;
		text-align: center;
		/* margin-left: 10px;
		margin-right: 10px; */
		/* min-width: calc(33.3333% - 20px) !important;
		max-width: calc(33.3333% - 20px) !important;
		flex: 0 1 calc(33.3333% - 20px) !important; */
		/* padding: 0; */
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Partners/Edit.vue